import { wrappedAxios as axios } from './axios';

import {
  Environment,
  resolveResponse,
  resolveRejected,
} from 'common';

export class EventProvider {

  static async getEventSiteConfig() {

    try {

      let url = `${Environment.uiHost}data/site-config.json?v=${new Date().getTime()}`;

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getPublicLiveEvents() {

    try {

      let url = `${Environment.apiHost}events`;

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getPastEvents(isFeatured = false) {

    try {

      let url = `${Environment.apiHost}events?isPast=true`;

      if (isFeatured) {
        url += `&isFeatured=true`;
      }

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getEventById(id) {

    try {

      let url = `${Environment.apiHost}events/${id}`;

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getProductsByEventId(event_id) {

    try {

      let url = `${Environment.apiHost}products/by-event?event_id=${event_id}`;

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getProductsByPlatform() {

    try {

      let url = `${Environment.apiHost}products/by-platform`;

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getSeating(eventId, orderId) {

    try {

      let url = `${Environment.apiHost}events/${eventId}/seating`;
      
      if (orderId) {
        url += `?order_id=${orderId}`;
      }

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getEventPrices(eventId) {

    try {

      let url = `${Environment.apiHost}event-price/${eventId}`;

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getReservedSeats(eventId, blockId, orderId) {

    try {

      let url = `${Environment.apiHost}tickets/event/${eventId}/reserved-seats`;
      
      const params = new URLSearchParams();
      if (blockId) {
        params.append('block_id', blockId);
      }
      if (orderId) {
        params.append('order_id', orderId);
      }
      
      if (params.toString()) {
        url += `?${params.toString()}`;
      }

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getProductById(id) {

    try {

      let url = `${Environment.apiHost}products/by-id/${id}`;

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getPackageById(id) {

    try {

      let url = `${Environment.apiHost}packages/${id}`;

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }

  static async getPackagesByEventId(event_id) {

    try {

      let url = `${Environment.apiHost}packages/event/${event_id}`;

      let res = await axios.get(url);

      return resolveResponse(res);

    } catch (ex) {

      return resolveRejected(ex);
    }
  }
}
